import React from "react";
// ANT DESIGN COMPONENTS
import { Dropdown, Menu, Space } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis, faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import {
	updateMessage,
	updateOpenForm,
	updateFormAction,
	updateOpenModalDelete,
} from "../../../redux/messages/messagesSlice";
// AUTHORIZATION
import validatePermission from "../../../utils/validatePermissions";
// COMPONENTS
import TableActionsMenuItem from "../../components/table/TableActionsMenuItem";
// INTERFACES
import { MessageTableActionsInterface } from "../../../interfaces/Message.interface";
import { RootState } from "../../../app/store";

function MessageTypeTableActions({ selectedItem }: MessageTableActionsInterface) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const dispatch = useDispatch();
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { permissions } = useSelector((state: RootState) => state.user);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const handleOpenModalDelete = () => {
		dispatch(updateMessage(selectedItem));
		dispatch(updateOpenModalDelete(true));
		dispatch(updateFormAction("EDIT"));
	};
	const handleOpenModalEdit = () => {
		dispatch(updateMessage(selectedItem));
		dispatch(updateOpenForm(true));
		dispatch(updateFormAction("EDIT"));
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// ROW ACTIONS ************************************ */
	const manageActions = () => {
		const EDIT = validatePermission("permission-not-defined", permissions)
			? {
					label: <TableActionsMenuItem icon={faPenToSquare} text={t("general.edit")} onClick={handleOpenModalEdit} />,
					key: "1",
			  }
			: null;
		const DELETE = validatePermission("permission-not-defined", permissions)
			? {
					label: <TableActionsMenuItem icon={faTrash} text={t("general.delete")} onClick={handleOpenModalDelete} />,
					key: "2",
			  }
			: null;

		return [EDIT, DELETE];
	};
	const menu = <Menu items={manageActions()} />;
	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			<Dropdown overlay={menu} trigger={["click"]}>
				<Space className='generalStyles__hoverCursor'>
					<FontAwesomeIcon icon={faEllipsis} />
				</Space>
			</Dropdown>
		</div>
	);
}

export default MessageTypeTableActions;
